// extracted by mini-css-extract-plugin
module.exports = {"container":"weddingInvitations_container__x76Xn","galleryContainer":"weddingInvitations_galleryContainer__bzFak"};